export interface Course {
  id?: number;
  subjectId: number;
  subjectName?: string;
  name: string;
  code: string;
  description?: string;
  startDate?: string;
  endDate?: string;
  maxStudents?: number;
  status?: CourseStatus;
  teacherId?: number;
  teacherName?: string;
  enrollmentCount?: number;
}

export enum CourseStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED'
}

export interface CreateCourseRequest {
  subjectId: number;
  name: string;
  code: string;
  description?: string;
  startDate?: string;
  endDate?: string;
  maxStudents?: number;
}
